import Vue from 'vue';
import SearchTable from './index.vue';

function componentsInstall(): void {
  Vue.component('search-table', SearchTable);
}

// tslint:disable-next-line: no-empty
const SearchTableFun = () => {};
SearchTableFun.install = () => {
  componentsInstall();
};

export default SearchTableFun;
